import React, { FC, useEffect, useState } from "react";

import SpaceScreen from "../atoms/SpaceScreen";
import { useLocation, useParams } from "react-router-dom";
import MainLayout from "../../Layouts/MainLayout";
import { service } from "../../../services/AxiosServices";
// Fetches space data based on the project_id and sets the space name, excluding the current space by id.

const SpaceScreenPage: FC = () => {
  const location = useLocation();

  const { title, spaceName } = location.state || {};
  const { id } = useParams();
  const [spacename,setSpacename] = useState('')
 
  useEffect(() => {
    const singleSpace = async () => {
     try{
      const response = await service<any>("api/get-spaces", "post", {
         project_id: localStorage.getItem("project_id"),
       });
       const formattedData = response?.data?.filter((ele:any)=>ele.id!== id).space_name
       console.log(formattedData)
       setSpacename(formattedData)
     }
     catch(err){

     }

    };
    singleSpace();
  }, [id]);


  return (
    <>
      <MainLayout>
        <SpaceScreen title={title || spacename} spaceName={spaceName} spaceId={id} />
      </MainLayout>
    </>
  );
};
export default SpaceScreenPage;
